import React, { type FunctionComponent } from 'react'
import { useListStoreGroups } from 'legacy/common/graphql/store-groups/list.hooks'
import { useTrackEvent } from 'utils/events/hooks'
import { StoreGroupsListContent } from 'legacy/sections/store-groups/components/list/StoreGroupsListContent'

export const StoreGroupsList: FunctionComponent = () => {
  useTrackEvent({
    id: 'settings.store_groups.list.viewed',
    description: 'Viewed the store groups list page',
  })
  const { storeGroups, loading, error } = useListStoreGroups()

  return <StoreGroupsListContent loading={loading} error={error} storeGroups={storeGroups} />
}
